import React from 'react'

function NotFound() {
  return (
    <div className='flex items-center justify-center text-3xl text-white'>Error - 404 Not found</div>
  )
}

export default NotFound